// src/app/modules/AccessControl/pages/AccessLogsTable.jsx
// Adaptive Access Logs Table - works for all access types

import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { ChevronLeft, ChevronRight } from 'lucide-react';
import * as columnFormatters from "./database";

export function AccessLogsTable({
  onCheckout,
  onPageChange,
  currentPage,
  perPage,
  getLabel,
  hasFeature
}) {
  const { access_logs, access_logs_meta, loading } = useSelector(
    (state) => ({
      access_logs: state.dashboard.accessLogs || [],
      access_logs_meta: state.dashboard.accessLogsMeta,
      loading: state.dashboard.actionsLoading,
    }),
    shallowEqual
  );

  const totalResults = access_logs_meta?.totalResults || 0;
  const totalPages = Math.max(1, Math.ceil(totalResults / (perPage || 10)));
  const showPurpose = hasFeature('showPurpose');

  if (loading && !access_logs.length) {
    return <div className="sety-tbl-sub" style={{ padding: 22 }}>Loading…</div>;
  }

  if (!access_logs.length) {
    return <div className="sety-tbl-sub" style={{ padding: 22 }}>No access logs found.</div>;
  }

  return (
    <div>
      <div className="sety-tbl-wrap">
        <table className="sety-tbl">
          <thead>
            <tr>
              <th>{getLabel('person')}</th>
              <th>{getLabel('destination')}</th>
              <th>Code</th>
              {showPurpose && <th>Purpose</th>}
              <th>Time</th>
              <th>Status</th>
              <th style={{ textAlign: 'right' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {access_logs.map((row) => (
              <tr key={row.log_id}>
                <td>{columnFormatters.PersonColumnFormatter(row.visitor_name, row, getLabel)}</td>
                <td>{columnFormatters.DestinationColumnFormatter(row.host_name, row, getLabel)}</td>
                <td className="sety-tbl-mono">
                  {row.code && row.code.length > 3
                    ? `${row.code.slice(0, 3)}${'*'.repeat(row.code.length - 3)}`
                    : row.code || '—'}
                </td>
                {showPurpose && <td>{row.purpose || '—'}</td>}
                <td>{columnFormatters.TimeColumnFormatter(row.entry_time, row)}</td>
                <td>{columnFormatters.StatusColumnFormatter(row.status, row)}</td>
                <td style={{ textAlign: 'right' }}>
                  {columnFormatters.ActionsColumnFormatter(null, row, 0, { onCheckout })}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '14px 22px', borderTop: '1px solid var(--ink-100)',
        }}>
          <span className="sety-tbl-sub">Page {currentPage} of {totalPages}</span>
          <div style={{ display: 'flex', gap: 8 }}>
            <button
              className="sety-btn sety-btn-ghost"
              disabled={currentPage <= 1}
              onClick={() => onPageChange(currentPage - 1)}
            >
              <ChevronLeft size={14} />Prev
            </button>
            <button
              className="sety-btn sety-btn-ghost"
              disabled={currentPage >= totalPages}
              onClick={() => onPageChange(currentPage + 1)}
            >
              Next<ChevronRight size={14} />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
